import { clone } from "lodash";
import { LibraryManager } from "../assets/library-manager";

export interface IMessage {
    type: 'onpluginsettingload' | 'getpluginparameter' | 'setpluginparameter' | 'pluginrpcresult' | 'onpluginsettingsave' | 'onpluginsettingpageload' | 'onpluginsettingchanged' | 'pluginparameterchanged';
    id: string;
    data: any;
}
export interface PluginSettingNode {
    id: string,
    pageData?: any;
    showInitPage: (result: any) => void;
    savePluginParameter: (result: any) => any;
    pluginParameterChanged: (result: any) => any;
    onRpcResult: (result: any) => void;
}
export class BefPluginProxyDataService {
    private static messagePromiseMap: Record<string, {
        id: string,
        resolve: (value: any | PromiseLike<any>) => void,
        reject: (reason?: any) => void
    }> = {};
    private static settingNode: PluginSettingNode;

    static init(node: PluginSettingNode) {
        BefPluginProxyDataService.settingNode = node;
        //注册事件，用于监听parent消息
        window.addEventListener('message', BefPluginProxyDataService.analyzeMessage);
    }
    private static async analyzeMessage(event: MessageEvent<IMessage>) {
        if (event.data) {
            switch (event.data.type) {
                case 'setpluginparameter': {
                    let result: { code: number, error: any } = { code: 0, error: null };
                    let message = clone(event.data);
                    try {
                        if (event.data.data?.plugin) await LibraryManager.init(event.data.data.plugin);
                        BefPluginProxyDataService.settingNode.pageData = event.data.data?.pageData;
                        BefPluginProxyDataService.settingNode.showInitPage(event.data.data);
                    } catch (err) {
                        result.code = 500;
                        result.error = err
                    }

                    message.data = result;
                    window.parent.postMessage(message, '*')
                    break;
                }
                case 'getpluginparameter': {
                    let result: { code: number, error: any, data?: any } = { code: 0, error: null };
                    let message = clone(event.data);
                    try {
                        result.data = BefPluginProxyDataService.settingNode.savePluginParameter(event.data.data);
                    } catch (err) {
                        result.code = 500;
                        result.error = err
                    }

                    message.data = result;
                    window.parent.postMessage(message, '*')
                    break;
                }
                case 'pluginrpcresult': {
                    BefPluginProxyDataService.settingNode.onRpcResult(event);
                    break;
                }
                case 'pluginparameterchanged': {
                    let result: { code: number, error: any, data?: any } = { code: 0, error: null };
                    let message = clone(event.data);
                    try {
                        result.data = BefPluginProxyDataService.settingNode.pluginParameterChanged(event.data.data);
                    } catch (err) {
                        result.code = 500;
                        result.error = err
                    }

                    message.data = result;
                    window.parent.postMessage(message, '*')
                    break;
                }
                default: {
                    // let messagePromise = BefPluginProxyDataService.messagePromiseMap[event.data.id]
                    // messagePromise.resolve(event.data.data)
                    //console.log(event.data);
                }
            }
        }
    }
    static isProxy(): boolean {
        return window.parent && window !== window.parent
    }
    static notifyOnLoad() {
        const message: IMessage = {
            id: BefPluginProxyDataService.settingNode.id,
            type: 'onpluginsettingload',
            data: null
        }
        window.parent.postMessage(message, '*')
    }
    static notifySave(data: any) {
        const message: IMessage = {
            id: BefPluginProxyDataService.settingNode.id,
            type: 'onpluginsettingsave',
            data: data
        }
        window.parent.postMessage(message, '*')
    }
    static getPluginPageRenderSchema(pageGroupName: string, pageName: string): any {
        if (!BefPluginProxyDataService.settingNode || !BefPluginProxyDataService.settingNode.pageData || BefPluginProxyDataService.settingNode.pageData.ID !== pageGroupName || !BefPluginProxyDataService.settingNode.pageData.Pages[pageName]) return null;
        return BefPluginProxyDataService.settingNode.pageData.Pages[pageName];
    }
    static notifyOnPageLoad() {
        const message: IMessage = {
            id: BefPluginProxyDataService.settingNode.id,
            type: 'onpluginsettingpageload',
            data: null
        }
        window.parent.postMessage(message, '*')
    }
    static notifyChange(data: any) {
        const message: IMessage = {
            id: BefPluginProxyDataService.settingNode.id,
            type: 'onpluginsettingchanged',
            data: data
        }
        window.parent.postMessage(message, '*')
    }
}